import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
} from 'react-router-dom'
import MainLayout from '@/components/layout/MainLayout'
import { AccountRoutes } from '@/pages/Account/routes.tsx'
import { ROUTES } from '@/utils/constants.ts'
import { Authenticated } from '@/utils/routing/Authenticated'
import { DantiRoute } from '@/utils/routing/DantiRoute'
import { RequireSubscription } from '@/utils/routing/RequireSubscription.tsx'
import { wrapCreateBrowserRouter } from '@sentry/react'
import { APP_ROUTES, ROOT_ROUTES, ROUTES_BY_PATH } from './constants'

export interface RouteProps {
  path: string
  Component: React.ComponentType<any>
  isFullscreen?: boolean
  feature?: string
  isSearchable?: boolean
}

export const renderRoute = (path: string) => {
  const route = ROUTES_BY_PATH[path]
  return (
    <Route
      key={path}
      data-testid={path}
      path={path}
      element={<DantiRoute {...route} />}
    />
  )
}

// This is typed but eslint doesn't believe it.

export const router = wrapCreateBrowserRouter(createBrowserRouter)(
  createRoutesFromElements(
    <>
      <Route data-testid="main-layout-route" element={<MainLayout />}>
        {ROOT_ROUTES.map(renderRoute)}
        <Route
          data-testid="authenticated-routes"
          element={
            <Authenticated>
              <RequireSubscription>
                <Outlet />
              </RequireSubscription>
            </Authenticated>
          }
        >
          {APP_ROUTES.map(renderRoute)}
          {AccountRoutes}
        </Route>
        <Route
          data-testid="authenticated-no-subscription-routes"
          element={
            <Authenticated>
              <Outlet />
            </Authenticated>
          }
        >
          {renderRoute(ROUTES.planSelection)}
        </Route>
      </Route>
    </>,
  ),
)
